import React from 'react'
import { Link } from 'gatsby'
import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import PriceDisplay from './price-display'
import PercentageOff from './percentage-off'
import useGetPrice from '../hooks/useGetPrice'
import setQueryParams from '../utilities/setQueryParams'

export default function ProductCardMini({ product, onClick, children }) {
    const {
        name,
        description,
        url,
        category,
        includes,
        image,
        badge,
    } = product || {}

    const BORDER_RADIUS = 12
    const is_collection = includes?.length > 0
    const { price } = useGetPrice(product)

    if (!product) return
    return (
        <Link
            to={url}
            className="d-flex position-relative bg-white text-black"
            onClick={onClick}
            style={{
                gridColumn: 'span 1',
                borderRadius: BORDER_RADIUS,
            }}
        >
            {/* IMAGE AND BADGE */}
            <div className='overflow-hidden flex-shrink-0'>
                {image && (
                    <img
                        src={setQueryParams(image, { format: 'webp', width: 160 })}
                        alt=''
                        style={{
                            borderTopLeftRadius: BORDER_RADIUS,
                            width: 80,
                            height: 80,
                        }}
                    />
                )}

                {(badge || price?.promotion_price) && <p
                    className="fw-bold mb-0 bg-primary shadow position-absolute"
                    style={{ left: -4, marginRight: -4, padding: '0px 12px', fontSize: 14 }}
                >
                    {badge ? badge : <><PercentageOff price={price} />% OFF</>}
                </p>}
            </div>

            {/* TITLE, CATEGORY, DESCRIPTION, INCLUDES/REQUIRES, PRICE */}
            <Card
                className="w-100 border-0 bg-transparent"
                style={{  padding: '20px 20px 16px' }}
            >
                <Card.Body className="p-0">
                    <Card.Title className="text-uppercase mb-3" style={{ fontSize: 24, lineHeight: '28px' }}>
                        {name}
                    </Card.Title>

                    <Card.Subtitle as='p' className="fw-semibold text-uppercase text-secondary mb-3">
                        {category?.replace('-', ' ')}
                    </Card.Subtitle>

                    <Card.Text
                        className='truncate-lines-2 mb-2'
                        title={description?.replace(/(<([^>]+)>)/gi, ' ')}
                    >
                        {description?.replace(/(<([^>]+)>)/gi, ' ').replace('&nbsp;', '')}
                    </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 p-0">
                    <div className="d-flex justify-content-between">
                        <PriceDisplay
                            product={product}
                            style={{ fontSize: 18 }}
                            className='fw-semibold'
                        />
                        {is_collection && <img src='/svg/is-collection-icon-black.svg' alt='' title='Type: Collection' />}
                    </div>
                </Card.Footer>
            </Card>
        </Link>
    )
}
